<template>
  <div>
    <form-container size="medium">
      <h1 class="page-title">{{ $t('onboarding.succeededTitle') }}</h1>

      <h4 class="subtitle">{{ $t('onboarding.nextSteps') }}</h4>

      <ul class="item-list">
        <li class="item">
          <p>{{ $t('onboarding.editAccount') }}</p>

          <router-link :to="{ name: 'edit'}">
            <b-button variant="primary">
              {{ $t('onboarding.editAccountButton') }}
            </b-button>
          </router-link>
        </li>

        <li class="item">
          {{ $t('onboarding.installApp') }}
          <div>
            <a :href="$t('onboarding.iosInstallUrl')">
              <img style="margin:9px;width:118px;" :alt="$t('onboarding.iosInstallTitle')" :src="$t('onboarding.iosInstallBadgeUrl')"/>
            </a>
            <a :href="$t('onboarding.androidInstallUrl')">
              <img style="margin:0;width:135px;" :alt="$t('onboarding.androidInstallTitle')" :src="$t('onboarding.androidInstallBadgeUrl')"/>
            </a>
          </div>
        </li>

        <li class="item" v-if="showHousebookControlLink">
          <p>{{ $t('onboarding.openHousebookControl') }}</p>

          <b-button href="https://control.housebook-solutions.com/" target="_blank" variant="primary">
            {{ $t('onboarding.openHousebookControlButton') }}
          </b-button>
        </li>
      </ul>
    </form-container>
  </div>
</template>

<script>
/**
* This screen is used as endpoint when the onboarding of a user succeeded.
* When on a desktop computer, a link to Housebook Control is shown for admin users.
* When on mobile, links for installing the app are shown.
*/
export default {
  name: 'OnboardingSuccessScreen',
  props: {
    showHousebookControlLink: Boolean
  }
}
</script>

<style scoped>
.subtitle {
  font-size: 1.5em;
  margin-top: 60pt;
}

.item-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.item {
  display: block;
  margin-top: 30pt;
  padding: 15pt;
  background-color: rgba(170, 170, 170, 0.2);
  border-radius: 10pt;

  font-size: 1.3em;
}
</style>



// WEBPACK FOOTER //
// src/components/OnboardingSuccessScreen.vue